import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { selectCurrentOrg } from "../../_features/auth/state/selectors";
import { CommandCenterProvider } from "../../_context/CommandCenterContext/CommandCenterProvider";
import { paths } from "./paths";

const PrivateRoute = () => {
  const token = useSelector((state) => state.auth.token);
  const selectedOrg = useSelector((state) => state.auth.user?.selectedOrg);
  const currentOrg = useSelector(selectCurrentOrg);

  if (!token) {
    return <Navigate to={paths.signIn} replace />;
  }

  if (!selectedOrg || currentOrg?.status?.toLowerCase() === "suspended") {
    return <Navigate to={paths.orgSelect} replace />;
  }

  return (
    <CommandCenterProvider>
      <Outlet />
    </CommandCenterProvider>
  );
};

export default PrivateRoute;
